<div class="bg_message"></div>
<div class="bottom_message" id="back_idea">
  <div class="wrap">
    <div class="ttl">{{ 'Pages.AddOffer.Save.Header' | translate }}</div>
    <div class="message">
      <div class="button_block clrfx">
        <a class="button small_radius w100 border_blue" (click)="save()">{{ 'Pages.AddOffer.Save.SaveButton' | translate }}</a>
        <a *ngIf="!offerStatusId" class="button small_radius w100 " (click)="delete()">{{ 'Pages.AddOffer.Save.DeleteButton' | translate }}</a>
        <a *ngIf="offerStatusId" class="button small_radius w100 " (click)="delete()">{{ 'Pages.AddOffer.Save.CloseButton' | translate }}</a>
      </div>
    </div>
    <a class="close close_modal_ref" (click)="activeModal.close()"></a>
  </div>
</div>
